import Stack from '@mui/material/Stack';
import { useEffect, useState, useRef } from 'react';
import { Form, TextInput, SaveButton, useNotify, useTranslate } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import { DashboardContent } from '../../../../../layouts/dashboard';
import { CustomBreadcrumbs } from '../../../../../components/custom-breadcrumbs';
import { getRangoConfig, updateRangoConfig } from '../../../services/swapUserRangoService';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';

function RangoInitializer({ setLoading }: { setLoading: (v: boolean) => void }) {
  const { setValue } = useFormContext();
  const notify = useNotify();
  const didFetch = useRef(false);

  useEffect(() => {
    if (didFetch.current) return;
    didFetch.current = true;

    (async () => {
      try {
        const res = await getRangoConfig();
        setValue('referralCode', res.referralCode ?? '');
      } catch (e: any) {
        notify(e?.message || 'loading failed', { type: 'error' });
      } finally {
        setLoading(false);
      }
    })();
  }, [notify, setLoading, setValue]);

  return null;
}

export default function Rango() {
  const t = useTranslate();
  const notify = useNotify();

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  // update code
  // const onSubmit = async (values: any) => {
  //   setSaving(true);
  //   try {
  //     await updateRangoConfig({
  //       referralCode: (values.referralCode || '').trim(),
  //     });
  //     notify(t('common.updated') || 'Code updated', { type: 'success' });
  //   } catch (e: any) {
  //     notify(e?.message || 'Update failed', { type: 'error' });
  //   } finally {
  //     setSaving(false);
  //   }
  // };

  return (
    <DashboardContent>
      <PermissionGuard resource="swap-rango-config" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={t('resource.swapConfigRango') || 'Rango'}
          links={[
            { name: t('resource.swap') || 'Swap', href: '#' },
            { name: t('resource.swapConfigRango') || 'Rango', href: '#' },
          ]}
          sx={{ mb: 3 }}
        />

        <Form defaultValues={{ referralCode: '' }} disableInvalidFormNotification>
          <RangoInitializer setLoading={setLoading} />

          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            spacing={2}
            mb={2}
          >
            <TextInput
              source="referralCode"
              label="module.swapConfigRango.referralCode"
              fullWidth
            />
          </Stack>

          <Stack direction="row" spacing={2}>
            {/* <PermissionGuard resource="swap-rango-config" action="update" fallback={<></>}> */}
            <SaveButton alwaysEnable disabled={loading || saving} />
            {/* </PermissionGuard> */}
          </Stack>
        </Form>
      </PermissionGuard>
    </DashboardContent>
  );
}
